export function pad2(n: number): string {
  return String(n).padStart(2, '0');
}

// Devuelve la fecha local del dispositivo como YYYY-MM-DD (con desfase lógico por defecto si es "ahora")
export function getLocalDateKey(date: Date = new Date(), forceOffset?: boolean): string {
  const isNow = Math.abs(date.getTime() - Date.now()) < 5000;
  const shouldApplyOffset = forceOffset !== undefined ? forceOffset : isNow;

  let offsetHours = 6;
  try {
    const stored = localStorage.getItem('family_transition_hour');
    if (stored !== null) {
      const parsed = parseInt(stored, 10);
      if (!isNaN(parsed)) {
        offsetHours = parsed;
      }
    }
  } catch (e) {
    // Ignorar errores en entornos fuera de navegador
  }

  const targetDate = shouldApplyOffset
    ? new Date(date.getTime() - offsetHours * 60 * 60 * 1000)
    : date;

  const y = targetDate.getFullYear();
  const m = pad2(targetDate.getMonth() + 1);
  const d = pad2(targetDate.getDate());
  return `${y}-${m}-${d}`;
}

// Convierte un Firestore Timestamp o Date a clave local YYYY-MM-DD
export function getLocalDateKeyFromAny(d: any): string {
  try {
    const jsDate = typeof d?.toDate === 'function' ? d.toDate() : (d instanceof Date ? d : new Date(d));
    return getLocalDateKey(jsDate);
  } catch {
    return getLocalDateKey(new Date());
  }
}

// Parsea 'YYYY-MM-DD' de un input date como fecha LOCAL (no UTC)
export function parseDateInputToLocalDate(input: string): Date {
  const [y, m, d] = input.split('-').map((v) => parseInt(v, 10));
  return new Date(y, (m || 1) - 1, d || 1);
}

// Parsea una clave 'YYYY-MM-DD' como fecha LOCAL
export function parseDateKeyToLocalDate(key: string): Date {
  return parseDateInputToLocalDate(key);
}
